import M_TreeCard from '@/components/M_Molecules/M_TreeCard/M_TreeCard';
import { useTree } from '../../contexts/TreeContext';
import styles from './TreePage.module.css';
import M_TreeHeader from '@/components/M_Molecules/M_TreeHeader/M_TreeHeader';

export default function TreePage() {
  const { trees } = useTree();

  return (
    <div className={styles.content}>
      <M_TreeHeader />
      <div className={styles.trees_grid}>
        {trees.map(tree => (
          <M_TreeCard tree={tree} />
        ))}
      </div>
    </div>
  );
}
